import { Component, OnInit } from '@angular/core';
import { MenuController } from '@ionic/angular';
@Component({
  selector: 'app-open-menu',
  templateUrl: './open-menu.component.html',
  styleUrls: ['./open-menu.component.scss'],
})
export class OpenMenuComponent implements OnInit {

  constructor(private menu: MenuController) { }

  ngOnInit() {}

  openEnd() {
    console.log("run");
    this.menu.open('end');
  }

}
